const initialState = {
  coreEvents: [],
  error: "",
};

export default initialState;
